<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="carHireTypes"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Allows the selection of a voucher type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-carHireType',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                carHireTypes: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getCarHireTypes();
        },
        methods: {
            getCarHireTypes:function(){
                axios.get('/api/car-hire-types')
                .then(function(response){
                    console.log(response);
                    var carHireTypes = [];
                    response.data.types.forEach(function(carHireType){
                        carHireTypes.push({ text: carHireType.car_hire, value: carHireType.car_hire_type_key });
                    });
                    this.carHireTypes = carHireTypes;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>

